import { Role } from 'constants/roles';

import { useMemo } from 'react';

import { UserRoleValue } from 'types/embedded/user';

export function useUserMerchantAccessPermission(rolesValues?: UserRoleValue[]) {
  return useMemo(() => {
    const roleAliases = rolesValues?.map((role) => role?.alias) || [];

    return (
      roleAliases.includes(Role.Payment) ||
      roleAliases.includes(Role.Risk) ||
      roleAliases.includes(Role.Observer)
    );
  }, [rolesValues]);
}
